import { Injectable, inject } from '@angular/core'
import { map } from 'rxjs/operators'
import { FileApiService, FilesFilterV2 } from 'src/api/file'
import { ElasticSearchService, ESPaginationParams, ESSortParams } from '../elastic-search'

@Injectable()
export class FileElasticSearchService extends ElasticSearchService {
  private FileApi = inject(FileApiService)


  filters(query?: any, columns?: string[]) {
    return this.FileApi.esSearchFilters({ query, columns }).pipe(
      map(filtersData => this.getViewFilters(filtersData)),
    )
  }

  search(payload: FilesFilterV2, pagination: ESPaginationParams, sorts: ESSortParams) {
    return this.FileApi.esSearch(payload, pagination, sorts).pipe(
      map(({ total, hits }) => ({ total, data: hits })),
    )
  }
}
